<template>
    <div id="divAutopay" class="dashboard-autopay mainArea top10 col-lg-12 col-md-12 col-sm-12" v-show="paymentMethodsLoaded && autoPayLoaded">
        <!-- Autopay Warning -->
        <div id="divWarnings" v-if="displayWarningIfNoDefaultPaymentExists" class="alert alert-warning text-center">
            <p>{{ $t("message.autoPayWarning") }}</p>
        </div>

        <!-- Autopay (Prepay) -->
        <div id="divAutoSetup" class="col-lg-6 col-md-6 col-sm-12" v-if="displayAutopaySection">
            <!-- AutoPay Description Text: if our Rep setting AutoPayVerbiageOverride is blank - display default text OR else display Rep setting value -->
            <p v-if="getAutopayDescriptionText === ''">{{ $t("message.autoPayMessage") }} </p>
            <p v-else v-html="getAutopayDescriptionText"></p> <br />
            <vue-numeric currency="$" separator="," v-model="autoPayAmount" :minus="false" :precision="2" class="form-control autopay-amt" 
                            :disabled="displayWarningIfNoDefaultPaymentExists"></vue-numeric>
            <div class="autopay-btns div-inline-block top5">
                <button id="btnSaveAutoPayAmount" class="btn btn-primary" @click.prevent="saveAutoPay(true)" :disabled="isSaveBtnDisabled || disableEditOrDelete" aria-label="Save">{{ $t("message.save") }}</button> 
                <button id="btnUnenroll" class="btn btn-primary" @click.prevent="unenrollAutopay()" :disabled="isUnenrollDisabled || disableEditOrDelete" aria-label="Unenroll">{{ $t("message.unenroll") }}</button>
            </div>            
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12" v-else>
            <label>{{ $t("message.noRecordsToDisplay") }}</label>
        </div>

        <!-- Payment Methods (Default) -->
        <div id="divDefaultPaymentMethod" class="col-lg-6 col-md-6 col-sm-12 custom-border-left custom-sm-padding-margin">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <h5>{{ $t("message.defaultSavedPayment") }}</h5>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12" v-show="paymentMethodsLoaded">
                <div class="panel panel-primary top10">
                    <div class="panel-body pad-left-0 pad-right-0">
                        <div id="divPaymentMethodContent" v-if="defaultPaymentMethod !== ''">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                <img id="imgAccountType" class="PayGo_card_icon_padding text-center" :src="getPaymentTypeImage(defaultPaymentMethod.SavedDefaultAccount.AccountType)" alt="Payment Icon" />
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 default-payment-name">
                                <h5 class="margin-top-0">{{ defaultPaymentMethod.SavedDefaultAccount.AccountName }}</h5>
                                <div v-if="defaultPaymentMethod.IsCreditCard">
                                    <p v-if="!defaultPaymentMethod.IsExpired">Exp: {{ defaultPaymentMethod.SavedDefaultAccount.ExpirationDate }}</p>
                                    <p v-else class="font-red"><b>{{ $t("message.expired") }}</b></p>
                                </div>
                                <div v-else>
                                    <p>{{ $t("message.routingNumber") }}: {{ defaultPaymentMethod.SavedDefaultAccount.RoutingNumber }}</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 default-payment-address PayGo_report_word_wrap">
                                <div class="card-text">
                                    <h5 id="nameOnAccount" class="margin-top-0">{{ defaultPaymentMethod.SavedDefaultAccount.NameOnAccount }}</h5>
                                    <p id="address1" v-html="defaultPaymentMethod.PaymentMethodAddress"></p>
                                </div>
                            </div>
                        </div>
                        <div id="divNoMethodMessage" v-else>
                            <p>{{ $t("message.noPaymentMethodAvailableMessage") }}</p>
                        </div>                        
                    </div>
                </div>
                <div class="text-center">
                    <button id="btnManageAccounts" class="btn btn-primary" @click.prevent="managePaymentMethods()" aria-label="Manage Payment Methods" :disabled="disableEditOrDelete">{{ $t("message.managePaymentMethods") }}</button>
                </div>
            </div>
        </div>

        <!-- Autopay Modal -->
        <modal v-show="isAutopayModalVisible" @close="closeModal">
            <h4 class="modal-title" slot="header">{{ $t("message.applyPaymentNow") }}</h4>
            <div slot="body">
                <div class="col-lg-12 top10">
                    <label>{{ $t("message.autopaySavedMessage", { autopayAmt: autoPayAmount.toFixed(2) }) }}</label>
                </div>
            </div>
            <div slot="footer">
                <button id="btnInitiatePayment" class="btn btn-sm btn-primary" @click.prevent="initiateAutopay()">{{ $t("message.ok") }}</button>
                <button id="btnCancel" class="btn btn-sm btn-primary" @click.prevent="closeModal()">{{ $t("message.cancel") }}</button>
            </div>
        </modal> 
    </div>
</template>

<script>
import axios from "axios";
import Modal from '@/components/common/Modal';
import VueNumeric from 'vue-numeric';

export default {
    name: 'Autopay',
    components: {
        Modal,
        VueNumeric
    },
    data() {
        return {
            defaultPaymentMethod: '',
            paymentMethodsLoaded: false,
            autoPayAmount: 0,
            originalAutoPayAmount: 0,
            autoPayLoaded: false,
            autoPayMinimum: 0,
            autoPayMaximum: null,
            autoPayData: {
                AutoPayMinimum: 0,
                AutoPayMaximum: null,
                AutoPayInformation: '',
                AutoPayVerbiageOverride: ''
            },
            isAutopayModalVisible: false,
            isUnenrollDisabled: true
        }
    },
    mounted() {
        this.getSavedDefaultPaymentMethod();
        this.getAutoPayInformation();
    },
    methods: {
        getSavedDefaultPaymentMethod() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Autopay/GetSavedDefaultPaymentMethod?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                this.defaultPaymentMethod = response;

                this.paymentMethodsLoaded = true;
            }, error => {
                console.log(error);
            });
        },
        getPaymentTypeImage(accountType) {
            switch(accountType) {
                case this.$PaymentAccountTypes.Visa:
                    return require('@/assets/img/visa.png');
                    break;
                case this.$PaymentAccountTypes.MasterCard:
                    return require('@/assets/img/mastercard.png');
                    break;
                case this.$PaymentAccountTypes.Discover:
                    return require('@/assets/img/discover.png');
                    break;
                case this.$PaymentAccountTypes.AmEx:
                    return require('@/assets/img/amex.png');
                    break;
                default:
                    return require('@/assets/img/bank.png');
                    break;
            }
        },
        managePaymentMethods() {
            this.$router.push({ name: 'Payment Management'});
        },
        getAutoPayInformation() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Autopay/GetAutoPayInformation?date=" + new Date().getTime() 
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.autoPayData = response;

                    var autoDraftAmount = this.autoPayData.AutoPayInformation.AutoDraftAmount === null ? 0 : this.autoPayData.AutoPayInformation.AutoDraftAmount;
                    // Save off the original Autopay amount (so we can use this value later for validating input)
                    this.originalAutoPayAmount = autoDraftAmount;
                    this.autoPayAmount = autoDraftAmount;

                    // Autopay Minimum (will be used for validation when saving a new auto pay amount)
                    this.autoPayMinimum = this.autoPayData.AutoPayMinimum.toFixed(2);
                    if(this.autoPayData.AutoPayMaximum){
                        this.autoPayMaximum = this.autoPayData.AutoPayMaximum.toFixed(2);
                    }

                    this.autoPayLoaded = true;

                    // 'Unenroll' button should be enabled if the user is enrolled with a valid autopay amount
                    this.isUnenrollDisabled = autoDraftAmount === 0; 
                }
            }, error => {
                console.log(error);
            });
        },
        saveAutoPay(isSave) {
            // Same method is used by 'Save' and 'Unenroll' buttons
            // isSave parameter is used to alter some of the behavior after we get a successful response back.

            // Save: Validate Input
            if (isSave) {
                var inputAmount = this.autoPayAmount;
                if (inputAmount < 0) {
                    this.showError("Please ensure that the amount is a positive numeric value.");
                    return;
                }

                if (inputAmount === 0) {
                    this.showError("Please ensure that the amount is greater than zero.");
                    return;
                }

                if (inputAmount < this.autoPayMinimum) {
                    this.showError("Autopay amount cannot be less than $" + this.autoPayMinimum);
                    return;
                }

                if (this.autoPayMaximum && inputAmount > this.autoPayMaximum) {
                    this.showError("The value entered is greater than the maximum allowed amount of $" + this.autoPayMaximum);
                    return;
                }
            }            

            // Save Autopay amount
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Autopay/SaveAutoPayAmount",
                data: {
                    amount: this.autoPayAmount,
                    originalAmount: this.originalAutoPayAmount
                } 
            }).then(result => {
                var response = result.data;
                if (response) {
                    // Display modal which gives the option to be able to initiate autopay or not.
                    this.isAutopayModalVisible = isSave ? true : false;

                    // Autopay amount has been successfully saved, let's go ahead and enable Unenroll button now
                    this.isUnenrollDisabled = false;

                    // Unenroll: display the success message for unenroll and disable 'Unenroll' button
                    if (!isSave) {
                        var successMessage = "Autopay has been unenrolled."
                        this.$toasted.global.success(successMessage);
                        this.$announcer.set(successMessage);
                        this.isUnenrollDisabled = true;
                    }
                }
            }, error => {
                console.log(error);
            });
        },
        initiateAutopay() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Autopay/InitiateAutopay?date=" + new Date().getTime(),
            }).then(result => {
                var response = result.data;
                if (!response) {
                    this.showError("An error occurred while trying to initiate a payment, please try again.");
                } else {
                    this.getAutoPayInformation();
                }
                this.isAutopayModalVisible = false;
            }, error => {
                console.log(error);
            });
        },
        unenrollAutopay() {
            // When user clicks on Unenroll we are going to reset Autopay amount back to zero
            this.autoPayAmount = 0;
            this.saveAutoPay(false);
        },
        closeModal() {
            this.isAutopayModalVisible = false;
            this.getAutoPayInformation();
        },
        showError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        }
    },
    computed: {
        displayWarningIfNoDefaultPaymentExists() {
            return this.paymentMethodsLoaded && this.defaultPaymentMethod === '';
        },
        isSaveBtnDisabled() {
            // If a default payment doesn't exist we will not enable Save button.
            if (!this.displayWarningIfNoDefaultPaymentExists) {
                return this.autoPayAmount <= 0 || this.autoPayAmount === this.originalAutoPayAmount;
            }
            return true;            
        },
        displayAutopaySection() {
            return this.autoPayLoaded && this.autoPayData.AutoPayInformation.ServiceLocationID > 0;
        },
        getAutopayDescriptionText() {
            return this.autoPayLoaded ? this.autoPayData.AutoPayVerbiageOverride : '';
        },
        disableEditOrDelete() {
            return this.$store.getters.getIsCSRReadOnly;
        }
    }
}
</script>

<style scoped>
.autopay-amt {
    border-radius: 0;
    height: 35px;
}

@media only screen and (max-width: 992px) {
    .custom-sm-padding-margin {
        padding-left: 0;
        margin-top: 20px;
        border-top: 1px solid #f3f3f3;
        padding-top: 10px;
    }
}
</style>